import { CurrentDataModel } from '@records/state/current-data/current-data.state';

/**
 * Destructure a record object, retrieving the usages array and the record data
 * as part of a new object.
 */
export const ExtractUsagesInfoAndRecord =
  (identifyAccessForUsages: (record: Record<string, any>) => Record<string, any>) =>
  /**
   * Destructure a record object, retrieving the usages array and the record data
   * as part of a new object.
   */
  (record: Record<string, any>): Pick<CurrentDataModel, 'usagesInfo' | 'record'> => {
    const result = { record: undefined, usagesInfo: undefined };
    if (record != null) {
      const recordWithUsageAccess = identifyAccessForUsages(record);
      const { usages, ...allData } = recordWithUsageAccess;
      result.record = allData;
      result.usagesInfo = usages;
    }
    return result;
  };
